/* eslint-disable */
import React, { useState, useEffect, useCallback } from "react";
/* Components */
import Button from "../button/button";
import { Controller, useForm } from "react-hook-form";
//import { getInstitutions } from '../../services/institution';
import { useMutation } from "react-query";
import { updateInstitutionPersonRegister, updateRegister } from "../../services/auth.service";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useTranslation } from "react-i18next";
import { MIX_PANEL_EVENTS } from "../../utils/constans";
import useSessionStore from "../../store/useSessionStore";
import debounce from "lodash.debounce";
import {
  getInstitutionsByName,
  storeInstitution,
} from "../../services/institution";
import {
  getCityByCountryAndRegion,
  getCountries,
  getRegionByCountry,
} from "../../services/location.service";
import ReactSelect from "react-select";
import AsyncSelect from "react-select/async";
import ModalForm from "../form-elements/modal-form/modalForm";
// import mixpanel from 'mixpanel-browser';

const SignUpFormInst = ({ onSignIn }) => {
  const [loading, setLoading] = useState(false);
  const { show } = useSnackbarStore();
  const [regions, setRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [institutionRegions, setInstitutionsRegions] = useState([]);
  const [institutionCountries, setInstitutionsCountries] = useState([]);
  const [institutionCities, setInstitutionsCities] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [, setDebouncedSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const userString = localStorage.getItem("user");
  const userObject = userString ? JSON.parse(userString) : {};
  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    //trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: userObject.id,
      email: userObject.email,
      first_name: userObject.first_name,
      last_name: userObject.last_name,
      country: "",
      country_code: "",
      //city: ''
    },
    mode: "onChange",
  });

  const { setInitialEvent } = useMixPanel();
  const { t, i18n } = useTranslation();
  // eslint-disable-next-line
  const [currentStep, setCurrentStep] = useState(1);
  const selectedCountryCode = watch("country_code");
  const selectedRegion = watch("region_id");
  const selectedCity = watch("city_id");
  const selectedInstitutionCountry = watch("country_institution");
  const selectedInstitutionRegion = watch("region_institution");
  const selectedInstitutionCity = watch("city_institution");
  const { setUser, setClearUserGoogle, setIsTeacherOnboarding } = useSessionStore();
  const email = watch("email");
  const first_name = watch("first_name");
  const last_name = watch("last_name");
  const country = watch("country_code");
  const institution = watch("institution");
  const newInstitution = watch("newInstitution");

  const SelectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "rgb(182 182 182 / 0.25)",
      borderColor: "transparent",
      borderRadius: "8px",
      caretColor: "white",
      "&:hover": { borderColor: "transparent" }, // Borde en hover
    }),
    input: (provided) => ({
      ...provided,
      color: "rgb(38, 38, 38)",
      fontWeight: "bold", // Establece el color del texto del input a blanco
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#F2F2F2" : "#FEFEFE",
      color: "black",
      cursor: "pointer",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#f8fafc", // Color del indicador
      "&:hover": {
        color: "#f8fafc", // Color del indicador en hover
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#f8fafc", // Establece el color del texto de la opción seleccionada a blanco
      fontWeight: "bold",
    }),
    clearIndicator: (styles) => ({
      ...styles,
      color: '#f8fafc',
      ':hover': {
        color: '#f8fafc', 
      },
    }),
  };

  const dataLocalUser = {
    user: {
      email,
      first_name,
      last_name,
      country,
      institution,
    },
  };

  // Actualiza debouncedSearchTerm después de que el usuario deja de escribir
  useEffect(() => {
    // Crea una función debounced que actualiza debouncedSearchTerm
    const debouncedUpdate = debounce((search) => {
      setDebouncedSearchTerm(search);
    }, 500); // 500 ms de espera

    if (searchTerm) {
      debouncedUpdate(searchTerm);
    }

    // Limpia el debounce si el componente se desmonta o el searchTerm cambia
    return () => debouncedUpdate.cancel();
    // eslint-disable-next-line
  }, [searchTerm]);

  // eslint-disable-next-line
  const debouncedLoadOptions = useCallback(
    debounce((inputValue, callback) => {
      if (!inputValue) {
        callback([]);
        return;
      }

      // useCallback para memorizar la función debounced
      getInstitutionsByName(inputValue).then((institutions) => {
        const options = institutions.map((institution) => ({
          label: institution.name,
          value: institution.id,
        }));
        if (options.length === 0) {
          // Si no hay opciones, muestra el modal
          setShowModal(true);
          setValue("newInstitution", inputValue);
        } else {
          setValue("newInstitution", "");
          // Si hay opciones, asegúrate de que el modal no se muestre
          setShowModal(false);
        }
        callback(options);
      });
    }, 1000),
    []
  );

  // eslint-disable-next-line
  const loadInstitutionOptions = (inputValue, callback) => {
    debouncedLoadOptions(inputValue, callback);
  };

  const mutationCountries = useMutation(getCountries, {
    onSuccess: (data) => {
      const countryOptions = data.map((country) => ({
        value: country.country_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setCountries(countryOptions);
      setInstitutionsCountries(countryOptions);
    },
    onError: (error) => {},
  });

  const mutationInstitutionCountries = useMutation(getCountries, {
    onSuccess: (data) => {
      const countryOptions = data.map((country) => ({
        value: country.country_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setInstitutionsCountries(countryOptions);
    },
    onError: (error) => {},
  });

  const mutationRegions = useMutation(getRegionByCountry, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.region_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setRegions(options);
      setInstitutionsRegions(options);
    },
    onError: (error) => {},
  });

  const mutationInstitutionRegions = useMutation(getRegionByCountry, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.region_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setInstitutionsRegions(options);
    },
    onError: (error) => {},
  });

  const mutationCity = useMutation(getCityByCountryAndRegion, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.city_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setCities(options);
      setInstitutionsCities(options);
    },
    onError: (error) => {},
  });

  const mutationInstitutionCity = useMutation(getCityByCountryAndRegion, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.city_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setInstitutionsCities(options);
    },
    onError: (error) => {},
  });

  const mutationStoreInstitution = useMutation(storeInstitution, {
    onSuccess: (data) => {
      getInstitutionsByName(data?.name).then((institutions) => {
        if (institutions.length > 0) {
          const newInstitution = institutions[0];
          setValue(
            "institution",
            { label: newInstitution.name, value: newInstitution.id },
            { shouldValidate: true }
          );
          setShowModal(false);
        }
      });
    },
    onError: (error) => {
      console.log("Error al registrar la institución", error);
      // Maneja el error según sea necesario
    },
  });

  useEffect(() => {
    if (selectedCountryCode) {
      mutationRegions.mutate({
        country: selectedCountryCode,
        lang: i18n.language,
      });
    }
    // eslint-disable-next-line
  }, [selectedCountryCode, setValue]);

  useEffect(() => {
    if (selectedRegion) {
      mutationCity.mutate({
        country: selectedCountryCode,
        region: selectedRegion,
        lang: i18n.language,
      });
    }
    // eslint-disable-next-line
  }, [selectedRegion]);

  useEffect(() => {
    if (selectedInstitutionRegion) {
      mutationInstitutionCity.mutate({
        country: selectedInstitutionCountry,
        region: selectedInstitutionRegion,
        lang: i18n.language,
      });
    }
    // eslint-disable-next-line
  }, [selectedInstitutionRegion]);

  useEffect(() => {
    if (showModal) {
      mutationInstitutionCountries.mutate(i18n.language);
    }
    // eslint-disable-next-line
  }, [showModal]);

  useEffect(() => {
    mutationCountries.mutate(i18n.language);
    // eslint-disable-next-line
  }, []);

  const onSubmit = (form) => {
    const dataLocalUser = {
      user: {
        email,
        first_name,
        last_name,
        country,
        institution,
      },
    };
    setLoading(true);
    const payload = {
      ...form,
      country: selectedCountryCode,
      // state: selectedRegion,
      // city: selectedCity,
    }
    console.log('payload', payload);
    mutation.mutate(payload);
  };

  const mutation = useMutation(updateInstitutionPersonRegister, {
    onSuccess: (data) => {
      setUser(data?.user);
      localStorage.setItem("token", data?.access_token);
      localStorage.setItem("user", JSON.stringify(data?.user));
      setLoading(false);
      setClearUserGoogle();
      setIsTeacherOnboarding(false);
      show(t("usuario_institucional_registrado_mensaje_correo"), "success", 10000);
    },
    onError: (error) => {
      if (error?.response.status === 401) {
        show(error.response.data.message, "error");
      }
      setLoading(false);
      setClearUserGoogle();
    },
  });

  const handleRegister = () => {
    handleSubmit(onSubmit)();
    setInitialEvent(dataLocalUser, MIX_PANEL_EVENTS.registerInstitutionStep1);
  };

  const handleRegisterInstitution = () => {
    const payload = {
      name: newInstitution,
      country: selectedInstitutionCountry,
      state: selectedInstitutionRegion,
      city: selectedInstitutionCity,
    };
    mutationStoreInstitution.mutate(payload);
  };

  return (
    <div className="flex flex-col gap-2">
      <form onSubmit={handleSubmit(onSubmit)} className="sign-up">
        <div className="w-full flex-1">
          <div className={`${currentStep === 1 ? "flex" : "hidden"} flex-col`}>
            <label className="input-label label-alt">
              {t("registroGoogleTitulo_step1")}
            </label>
            <div className="input-row">
              <div className="input-text mt-0">
                <label className="input-label text-Grey-500 text-4">
                  {t("firstName")}(s):
                </label>
                <input
                  className="input-box"
                  type="text"
                  {...register("first_name", {
                    required: t("requiredFirstName"),
                  })}
                />
                {errors.first_name && (
                  <span className="error">{errors.first_name.message}</span>
                )}
              </div>
              <div className="input-text mt-0">
                <label className="input-label text-Grey-500 text-4">
                  {t("lastName")}(s):
                </label>
                <input
                  className="input-box"
                  type="text"
                  {...register("last_name", {
                    required: t("requiredLastName"),
                  })}
                />
                {errors   .last_name && (
                  <span className="error">{errors.last_name.message}</span>
                )}
              </div>
            </div>
            <div className="input-row">
              <div className="input-text mt-2 flex-1">
                {/* Selector de País */}
                <label className="input-label text-Grey-500 text-4">
                  {t("registro_qPais")}
                </label>
                <Controller
                  name="country_code"
                  control={control}
                  rules={{ required: t("campo_requerido") }}
                  render={({ field }) => (
                    <ReactSelect
                      {...field}
                      value={countries.find(
                        (option) => option.value === field.value
                      )}
                      options={countries}
                      placeholder={t("seleccionar_pais")}
                      onChange={(option) => {
                        if(option === null){
                          setValue("country_code", null);
                        }
                        field.onChange(option?.value);
                      }}
                      styles={SelectStyles}
                      isMulti={false}
                      maxMenuHeight={100}
                      menuPlacement="bottom"
                      isClearable
                      backspaceRemovesValue
                    />
                  )}
                />
                {errors.country_code && (
                  <span className="error">{errors.country_code.message}</span>
                )}
              </div>

              {/* <div className="input-text mt-2 flex-1">
              
                <label className="input-label dark:text-Grey-500 ">
                  {t("registro_qEstado")}
                </label>
                <Controller
                  name="region_id"
                  control={control}
                  rules={{ required: t("campo_requerido") }}
                  disabled={!selectedCountryCode && !regions.length}
                  render={({ field }) => (
                    <ReactSelect
                      {...field}
                      value={regions.find(
                        (option) => option.value === field.value
                      )}
                      options={regions}
                      placeholder={"Seleccionar Estado"}
                      onChange={(option) => {
                        if (typeof option === "object" && option !== null) {
                          setValue("region_institution", option.value);
                          field.onChange(option.value);
                        }
                      }}
                      styles={SelectStyles}
                      isMulti={false}
                      maxMenuHeight={100}
                      menuPlacement="bottom"
                    />
                  )}
                />
                {errors.country_code && (
                  <span className="error">{errors.country_code.message}</span>
                )}
              </div> */}
            </div>
            {/* <div className="input-row">
              <div className="input-text mt-2 flex-1">
                <label className="input-label dark:text-Grey-500 ">
                  {t("registro_qCiudad")}
                </label>
                <Controller
                  name="city_id"
                  control={control}
                  rules={{ required: t("campo_requerido") }}
                  render={({ field }) => (
                    <ReactSelect
                      {...field}
                      value={cities.find(
                        (option) => option.value === field.value
                      )}
                      options={cities}
                      placeholder={t("seleccionar_ciudad")}
                      onChange={(option) => {
                        if (typeof option === "object" && option !== null) {
                          setValue("city_institution", option.value);
                          field.onChange(option.value);
                        }
                      }}
                      styles={SelectStyles}
                      isMulti={false}
                      maxMenuHeight="200px"
                      menuPlacement="bottom"
                    />
                  )}
                />
                {errors.city_id && (
                  <span className="error">{errors.city_id.message}</span>
                )}
              </div>
            </div> */}
            <div className="input-text mt-2">
              <label className="input-label text-Grey-500 text-4">
                {t("registro_qPerfil")}
              </label>
              <textarea
                className="textarea"
                type="text-area"
                rows="2"
                cols="50"
                placeholder={t('formulario_perfil_placeholder')}
                maxLength="500"
                {...register("profile", { required: t("campo_requerido") })}
              />
              {errors.profile && (
                <span className="error">{errors.profile.message}</span>
              )}
            </div>
            <div className="input-text flex-row items-center mt-6">
              <label className="input-label text-Grey-500 text-4">
                {t("registro_qNumeroEstudiantes")}
              </label>
              <input
                className="input-box max-w-full"
                type="number"
                {...register("number_students", {
                  required: t("campo_requerido"),
                })}
              />
              {errors.number_students && (
                <span className="error">{errors.number_students.message}</span>
              )}
            </div>
            <div className="input-row mt-6">
              <div className="input-text mt-2 flex-1">
                <label
                  htmlFor="terms"
                  className="w-full flex flex-row justify-center gap-1 text-Grey-500 text-3.5 font-bold"
                >
                  <input
                    type="checkbox"
                    id="terms"
                    {...register("terms", { required: t("campo_requerido") })}
                  />
                  <span>
                    {t("acepatcionTerminos_check1")}
                    <a
                      href="https://www.mentu.la/tratamiento-de-datos"
                      className="underline text-shaiaBlue"
                    >
                      {t("acepatcionTerminos_check1a")}
                    </a>
                  </span>
                </label>
                {errors.terms && (
                  <span className="error">{errors.terms.message}</span>
                )}
              </div>
              <div className="input-text mt-2 flex-1">
                <label
                  htmlFor="data_processing"
                  className="w-full flex flex-row justify-center gap-1 text-Grey-500 text-3.5 font-bold"
                >
                  <input
                    type="checkbox"
                    id="data_processing"
                    {...register("data_processing", {
                      required: t("campo_requerido"),
                    })}
                  />
                  <span>
                    {t("acepatcionTerminos_check2")}
                    <a
                      href="https://www.mentu.la/autorizacion-de-tratamiento-de-datos"
                      className="underline text-shaiaBlue"
                    >
                      {t("acepatcionTerminos_check2a")}
                    </a>
                  </span>
                </label>
                {errors.data_processing && (
                  <span className="error">
                    {errors.data_processing.message}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
      <div className="step-buttons !justify-center">
        <Button
          label={loading ? t("creatingUser") : t("createUser")}
          variant="secondary"
          onClick={handleRegister}
        />
      </div>
    </div>
  );
};

export default SignUpFormInst;
